if (!customElements.get('custom-star-rating')) {
  customElements.define(
    'custom-star-rating',
    class CustomStarsReviews extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', () => this.loadStars());
      }

      loadStars() {
        if (typeof okendoData !== 'undefined') {
          const parser = new DOMParser();
          const doc = parser.parseFromString(okendoData, 'text/html');
          const scriptTag = doc.getElementsByTagName('script')?.[0];
          const scriptContent = scriptTag?.textContent || null;

          if (scriptContent) {
            try {
              const data = JSON.parse(scriptContent);
              const reviewCountByLevel = data?.reviewAggregate?.reviewCountByLevel || {};
              const reviewCount = data?.reviewAggregate?.reviewCount || 1;
              this.setReviewsId();

              const average = this.getAverage(reviewCountByLevel, reviewCount);
              const averageRounded = this.getAverageRounded(average);
              this.displayData(averageRounded, reviewCount);
            } catch (error) {
              console.error('Error parsing JSON:', error);
            }
          } else {
            console.error('Okendo data error');
          }
        }
      }

      setReviewsId() {
        const reviewEl = document
          .querySelector('[id^="shopify-block-okendo_reviews_widget"]')
          ?.getElementsByTagName('div')?.[0];
        if (reviewEl) {
          reviewEl.id = 'reviews';
        }
      }

      colorStars(averageRounded) {
        const reviewStarsEl = document.getElementById('stars-foreground');
        const colorStarsPercentage = this.toPercentage(Number(averageRounded) / 5);
        reviewStarsEl.style.width = colorStarsPercentage;
      }

      displayData(averageRounded, reviewCount) {
        const customStarsReviewsEl = document.getElementById('custom-star-rating');
        const reviewEl = document.getElementById('review-rate');
        const reviewCounterEl = document.getElementById('review-counter');
        reviewEl.textContent = averageRounded;
        this.colorStars(averageRounded);
        reviewCounterEl.textContent = reviewCount;
        customStarsReviewsEl.style.display = 'block';
      }

      getAverage(reviewCountByLevel, reviewCount) {
        const { level1Count, level2Count, level3Count, level4Count, level5Count } = reviewCountByLevel;
        return (
          (this.getValue(level1Count) * 1 +
            this.getValue(level2Count) * 2 +
            this.getValue(level3Count) * 3 +
            this.getValue(level4Count) * 4 +
            this.getValue(level5Count) * 5) /
          Number(reviewCount)
        );
      }

      getAverageRounded(average) {
        return average > 4.9 ? this.floorToOneDecimalPlace(average) : this.roundToOneDecimalPlace(average);
      }

      getValue(levelCounter) {
        return levelCounter ? Number(levelCounter) : 0;
      }

      toPercentage(num) {
        return (num * 100).toFixed(2) + '%';
      }

      floorToOneDecimalPlace(num) {
        return Math.floor(num * 10) / 10;
      }

      roundToOneDecimalPlace(num) {
        return Math.round(num * 10) / 10;
      }
    }
  );
}
